import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MultiInputTimeRangeField } from '@mui/x-date-pickers-pro';
import { DateRange } from '@mui/x-date-pickers-pro';
import dayjs, { Dayjs } from 'dayjs';
import Box from '@mui/material/Box';
import { useTranslationContext } from '../../../../context/TranslationContext';

type Props = {
  value: DateRange<Dayjs> | null;
  handleChange: (newValue: DateRange<Dayjs>) => void;
  userTimeFormat?: string;
};

const CustomPropertyTimeRangePicker = ({ value, handleChange, userTimeFormat }: Props) => {
  const t = useTranslationContext();
  const initDates: DateRange<Dayjs> = [
    dayjs().set('hour', 0).set('minute', 0),
    dayjs().set('hour', 0).set('minute', 0),
  ];

  const timeFormat = userTimeFormat === '24' ? 'HH:mm' : 'hh:mm';

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ overflow: 'visible', paddingTop: '0px' }}>
        <MultiInputTimeRangeField
          slotProps={{
            textField: ({ position }) => ({
              label: position === 'start' ? t('contactEdit.from') : t('contactEdit.to'),
              size: 'small',
              variant: 'standard',
              inputProps: {
                placeholder: timeFormat,
              },
            }),
          }}
          value={value ? value : initDates}
          onChange={(newValue) => handleChange(newValue)}
          format={timeFormat}
        />
      </Box>
    </LocalizationProvider>
  );
};

export default CustomPropertyTimeRangePicker;
